/* eslint-disable no-empty */
import {
  Club,
  RequestStripeGetProration,
  RequestStripePostDowngradeSubscription,
  RequestStripePostUpgradeSubscription,
  ResponseStripeGetProration,
  ResponseStripePostDowngradeSubscription,
  ResponseStripePostUpgradeSubscription,
  ResponseStripeProducts,
} from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const stripeApi = createApi({
  reducerPath: 'apiStripe',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    fetchProducts: builder.query<ResponseStripeProducts, void>({
      query: (request) => 'stripe/products',
    }),
    fetchProration: builder.query<
      ResponseStripeGetProration,
      RequestStripeGetProration
    >({
      query: ({ new_price_id, downgrade }) => ({
        url: `/stripe/proration`,
        method: 'GET',
        params: {
          'new-price-id': new_price_id,
          downgrade: downgrade,
        },
      }),
    }),
    upgradeSubscription: builder.mutation<
      ResponseStripePostUpgradeSubscription,
      RequestStripePostUpgradeSubscription
    >({
      query: (request) => ({
        url: `/stripe/upgrade`,
        method: 'POST',
        body: request,
      }),
    }),
    downgradeSubscription: builder.mutation<
      ResponseStripePostDowngradeSubscription,
      RequestStripePostDowngradeSubscription
    >({
      query: (request) => ({
        url: `/stripe/downgrade`,
        method: 'POST',
        body: request,
      }),
    }),
    cancelDowngradeSubscription: builder.mutation<Club, any>({
      query: (request) => ({
        url: `/stripe/downgrade/cancel`,
        method: 'POST',
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useFetchProductsQuery,
  useFetchProrationQuery,
  useUpgradeSubscriptionMutation,
  useDowngradeSubscriptionMutation,
  useCancelDowngradeSubscriptionMutation,
  reducerPath,
  reducer,
  middleware,
} = stripeApi;
